import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { prop } from "ramda";
import useTranslate from "hooks/use-translate-language";

const Message = ({
  index,
  author,
  body,
  userId,
  attributes,
  timestamp,
  readInfo,
  isLastOwnMessage
}) => {
  if (!author) return <LogMsg body={body} />;
  return userId === author ? (
    <UserMsg
      body={body}
      timestamp={timestamp}
      authorName={prop("authorName", attributes)}
      readInfo={readInfo}
      isLastMessage={isLastOwnMessage}
      isLastMessageIndex={index}
    />
  ) : (
    <ParticipantMsg
      body={body}
      timestamp={timestamp}
      authorName={prop("authorName", attributes)}
    />
  );
};

Message.propTypes = {
  author: PropTypes.string,
  body: PropTypes.string.isRequired,
  userId: PropTypes.string,
  attributes: PropTypes.object,
  timestamp: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ])
};

export default Message;

const ParticipantMsg = ({ authorName, timestamp, body }) => {
  const formattedTime = moment(timestamp).format("hh:mm a");

  return (
    <div className={`message participant-msg`}>
      <div className="msg-details">
        <div className="msg-timestamp">
          {formattedTime}
        </div>
        <div className="divider" aria-hidden="true">-</div>
        <div className="msg-author">{authorName}</div>
      </div>
      <div className="msg-body">{body}</div>
    </div>
  );
};

ParticipantMsg.propTypes = {
  authorName: PropTypes.string,
  body: PropTypes.string.isRequired,
  timestamp: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ])
};

const UserMsg = ({ timestamp, body, readInfo, isLastMessageIndex, isLastMessage }) => {
  const translate = useTranslate();
  const formattedTime = moment(timestamp).format("hh:mm a");
  const meLabel = translate("me");
  const isRead = isLastMessage && readInfo?.lastReadMessageIndex === isLastMessageIndex;

  return (
    <div className={`message my-msg`}>
      <div className="msg-details">
        <div className="msg-author">{meLabel}</div>
        <div className="divider" aria-hidden="true">-</div>
        <div className="msg-timestamp">
          {formattedTime}
        </div>
      </div>
      <div className="msg-body">{body}</div>
      {isRead && (
        <span className="author-message-read-info">
          {`Read at ${
            readInfo.lastReadTimestamp !== null
              ? moment(readInfo.lastReadTimestamp).format("hh:mm A ")
              : ""
          }`}
        </span>
      )}
    </div>
  );
};

UserMsg.propTypes = {
  authorName: PropTypes.string,
  body: PropTypes.string.isRequired,
  timestamp: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  readInfo: PropTypes.object,
  isLastMessage: PropTypes.bool,
  isLastMessageIndex: PropTypes.number
};

const LogMsg = ({ body }) => (
  <div className="message log">
    <div className="msg-body">{body}</div>
  </div>
);

LogMsg.propTypes = {
  body: PropTypes.string.isRequired
};
